export const navData = () => {
    const primaryLinks = [
        {
            to: '#Landing',
            title: 'Welcome',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Welcome'
                }
            ]
        },
        {
            to: '#Flex',
            title: 'Season Membership',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Season Membership'
                }
            ]
        },
        {
            to: '#Seating',
            title: 'Seating & Pricing',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Seating & Pricing'
                }
            ]
        },
        {
            to: '#Notice',
            title: 'Rays Ticket Assurance',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Rays Ticket Assurance'
                }
            ]
        },
        {
            to: '#CoreBenefits',
            title: 'Season Member Benefits',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Season Member Benefits'
                }
            ]
        },
        {
            to: '#Membership',
            title: 'Member Profile',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Member Profile'
                }
            ]
        },
        {
            to: '#Renew',
            title: 'How to Renew',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Seating & Pricing'
                }
            ]
        },
        {
            to: '#Payment',
            title: 'Payment Options',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Seating & Pricing'
                }
            ]
        },
        {
            to: '#Schedule',
            title: 'Schedule',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Seating & Pricing'
                }
            ]
        },
        {
            to: '#Faq',
            title: 'Frequently Asked Questions',
            anchors: [
                {
                    anchor: '#header',
                    title: 'Frequently Asked Questions'
                }
            ]
        }
    ];
    return {
        primaryLinks
    };
};

